import api from './index'

class SettingService {
	fetchSetting() {
		return api.get('/setting/website')
	}
	saveSetting(data) {
		return api.post('/setting/website', data)
	}

	addBank(data) {
		return api.post('/setting/banks', data)
	}
	saveBank(data) {
		return api.patch(`/setting/banks/${data.oldAccountNumber}`, data)
	}
	deleteBank(data) {
		return api.delete(`/setting/banks/${data}`)
	}
	setMainDeposit(data) {
		return api.post(`/setting/banks/${data}/main-deposit`)
	}

	saveWithdrawAccount(data) {
		return api.post('/setting/website/withdraw-account', data)
	}
	saveCashback(data) {
		return api.post('/setting/website/cashback', data)
	}

	requestTruewalletOTP(data) {
		return api.post('/setting/truewallet/request-otp', data)
	}
	confirmTruewalletOTP(data) {
		return api.post('/setting/truewallet/confirm-otp', data)
	}

	getSCBAccounts() {
		return api.get('/setting/scb')
	}
	getSCBBalance(account) {
		return api.get(`/setting/scb/${account}/balance`)
	}
	requestAddSCB(data) {
		return api.post('/setting/scb', data)
	}
	confirmAddSCB(deviceID, data) {
		return api.post(`/setting/scb/${deviceID}/confirm-otp`, data)
	}
	toggleSCB(accountNo) {
		return api.post(`/setting/scb/${accountNo}/toggle`)
	}
	toggleHideSCB(accountNo) {
		return api.post(`/setting/scb/${accountNo}/toggle-hide`)
	}
	deleteSCB(accountNo) {
		return api.delete(`/setting/scb/${accountNo}`)
	}

	getSCBAuto() {
		return api.get('/setting/scb-auto')
	}
	getAllSCBAutoTx(params) {
		return api.get('/setting/scb-auto/transactions', {
			params
		})
	}
	saveSCBAuto(data) {
		return api.post('/setting/scb-auto', data)
	}

	saveAMBPayment(payload) {
		return api.post('/setting/website/amb-payment', payload)
	}
}

export default new SettingService()